import React from 'react';

interface MetricsCardProps {
  icon: string;
  value: string;
  label: string;
  color?: 'red' | 'blue' | 'green' | 'gray';
}

export default function MetricsCard({ icon, value, label, color = 'gray' }: MetricsCardProps) {
  const colorClasses = {
    red: 'text-[#E31837]',
    blue: 'text-[#006491]',
    green: 'text-green-600',
    gray: 'text-gray-700',
  };
  
  return (
    <div className="bg-white rounded-2xl p-4 shadow-md border border-gray-100">
      <div className="flex items-center gap-3">
        <div className={`w-12 h-12 rounded-full bg-gray-50 flex items-center justify-center ${colorClasses[color]}`}>
          <i className={`${icon} text-2xl`}></i>
        </div>
        <div>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
          <p className="text-sm text-gray-600">{label}</p>
        </div>
      </div>
    </div>
  );
}
